module.exports = __webpack_public_path__ + "img/iPhone7_sml-94db53a9d8e3d41a612571bb12b4fdd2.png";